import {
    Activity,
    FileText,
    LifeBuoy,
    GraduationCap,
    LayoutGrid,
    Settings,
    Zap,
    CreditCard
} from 'lucide-react';

export const adminNavItems = [
    { path: '/dashboard', label: 'Finanzas', icon: Activity },
    { path: '/admin/billing', label: 'Facturas', icon: CreditCard },
    { path: '/admin/flyder', label: 'Flyder', icon: Zap, highlight: true },
    { path: '/admin/resources', label: 'Documentos', icon: FileText },
    { path: '/admin/support', label: 'Ayuda', icon: LifeBuoy },
    { path: '/admin/academy', label: 'Academia', icon: GraduationCap },
    { path: '/admin/kanban', label: 'Tareas', icon: LayoutGrid },
    { path: '/profile', label: 'Ajustes', icon: Settings },
];

export const franchiseNavItems = [
    { path: '/dashboard', label: 'Finanzas', icon: Activity },
    // Flyder va entre Finanzas y Operativa porque es el puente entre las dos:
    // los pedidos que entran deciden las horas que se planifican.
    { path: '/flyder', label: 'Flyder', icon: Zap },
    { path: '/operations', label: 'Turnos', icon: LayoutGrid },
    { path: '/resources', label: 'Documentos', icon: FileText },
    { path: '/support', label: 'Ayuda', icon: LifeBuoy },
    { path: '/academy', label: 'Academia', icon: GraduationCap },
];

export const riderNavItems = [
    { path: '/rider/dashboard', label: 'Inicio', icon: Activity },
    { path: '/rider/schedule', label: 'Agenda', icon: LayoutGrid },
    { path: '/rider/profile', label: 'Ajustes', icon: Settings },
    { path: '/academy', label: 'Academia', icon: GraduationCap },
];
